import { Grid, Typography } from "@mui/material";
import { Box } from "@mui/system";
import { GetSummaryColorCode } from "../../../../app/utils/util";
import AppInformationText from "../../../../app/components/AppInformationText";
import { SummaryDto } from "../../../../app/models/summary/summaryDto";
import { useAppDispatch, useAppSelector } from "../../../../app/store/configureStore";
import { useEffect, useState } from "react";
import cpdCategoriesFormModel from "../../../pcsCpd/common/cpdCategoriesFormModel";
import { ApiRequestStatus } from "../../../../app/enums/apiRequestStatus";
import LoadingComponent from "../../../../app/layout/LoadingComponent";
import { MESSAGE_PROCESSING_DETAILS } from "../../../../app/utils/constant";
import { getCreditSummaryAsync } from "../../../../app/slices/pcsSlice";


export function CreditSummary() {
    const {
        formField: {
            AccreditedCeActivity,
            ProfessionalDevelopmentPlan,
            PracticeReview,
            WorkbasedLearning,
            OnTarget
        }
    } = cpdCategoriesFormModel;

    const { currentYear, legacySummaryData, getCreditSummaryStatus } = useAppSelector(state => state.pcs);
    const dispatch = useAppDispatch();

    useEffect(() => {
        if (legacySummaryData === null && getCreditSummaryStatus === ApiRequestStatus.Idle) {
            dispatch(getCreditSummaryAsync());
        }
    }, [legacySummaryData, getCreditSummaryStatus, dispatch]);

    const [creditSummarydata, setCreditSummaryData] = useState<SummaryDto[] | null>(null);
    const [isYearPartialyCompleted, setIsYearPartialyCompleted] = useState<boolean>(false);

    useEffect(() => {
        if (legacySummaryData && currentYear !== null) {
            legacySummaryData.map((item: SummaryDto[]) => {
                if (item[0].text.substring(0, 4) === (currentYear - 1).toString()) {
                    setCreditSummaryData(item);
                }

                let isYearPartialyComplete = false;
                if (item[2].text.toLowerCase() === "true") {
                    if (isYearPartialyComplete === false) {
                        setIsYearPartialyCompleted(true);
                    }
                }
            });
        }
    }, [legacySummaryData, currentYear]);

    const creditSummaryHelpText = () => {
        return <>
            Green - Credits on Target<br></br>
            Yellow - Credits Approaching Target<br></br>
            Red - Credits not on target<br></br>
        </>
    }

    if (getCreditSummaryStatus === ApiRequestStatus.Pending) {
        return <LoadingComponent message={MESSAGE_PROCESSING_DETAILS} />
    }

    return <Box sx={{
        "& .MuiPaper-root": {
            width: "unset",
            marginLeft: "0"
        }
    }}>
        <Box sx={{ minWidth: "100%", display: { xs: 'none', sm: 'block' } }}>
            <Grid container rowSpacing={4} sx={{ paddingTop: "5%" }}>

                <Grid size={{ xs: 6, md: 2, sm: 3 }}>
                    <Typography variant='h5' sx={{ fontWeight: '550' }}>Credit summary</Typography>
                </Grid>

                <Grid size={{ xs: 1, md: 1, sm: 1 }} sx={{ marginTop: '-7px' }}>
                    <AppInformationText information_text={creditSummaryHelpText()} placement={"top"} />
                </Grid>

                <Grid size={{ xs: 5, md: 9, sm: 8 }}></Grid>
            </Grid>
        </Box>

        <Box sx={{ minWidth: "90%", width: "98%", display: { xs: 'none', sm: 'block' } }}>
            <Grid container rowSpacing={4}>

                <Grid size={{ xs: 12 }}></Grid>

                <Grid size={{ xs: 1 }} sx={{ textAlign: 'start', wordBreak: 'break-all' }}>
                    <b>PCS Year</b>
                </Grid>

                <Grid size={{ xs: 2 }} sx={{ textAlign: 'center', paddingLeft: '1%', paddingRight: '1%' }}>
                    <b>Engaged in  Practice of Medicine</b>
                </Grid>

                <Grid size={{ xs: 1.5 }} sx={{ textAlign: 'center', paddingLeft: '1%', paddingRight: '1%' }}>
                    <b>{AccreditedCeActivity.label}</b>
                    <br />
                    <AppInformationText information_text={AccreditedCeActivity.informationText} placement="bottom" />
                </Grid>

                <Grid size={{ xs: 1.5 }} sx={{ textAlign: 'center', paddingLeft: '1%', paddingRight: '1%' }}>
                    <b>{ProfessionalDevelopmentPlan.label}</b>
                    <br />
                    <AppInformationText information_text={ProfessionalDevelopmentPlan.informationText} placement="bottom" />
                </Grid>

                <Grid size={{ xs: 1.5 }} sx={{ textAlign: 'center', paddingLeft: '1%', paddingRight: '1%' }}>
                    <b>{PracticeReview.label}</b>
                    <br />
                    <AppInformationText information_text={PracticeReview.informationText} placement="bottom" />
                </Grid>

                <Grid size={{ xs: 1.5 }} sx={{ textAlign: 'center', paddingLeft: '1%', paddingRight: '1%' }}>
                    <b>{WorkbasedLearning.label}</b>
                    <br />
                    <AppInformationText information_text={WorkbasedLearning.informationText} placement="bottom" />
                </Grid>

                <Grid size={{ xs: 1.5 }} sx={{ textAlign: 'center', paddingLeft: '1%', paddingRight: '1%' }}>
                    <b>{OnTarget.label}</b>
                    <br />
                    <AppInformationText information_text={OnTarget.informationText} placement="bottom" />
                </Grid>

                <Grid size={{ xs: 1.5 }} sx={{ textAlign: 'center', paddingLeft: '1%', paddingRight: '1%' }}>
                    <b>Verification Status</b>
                </Grid>
            </Grid>

            <Grid container sx={{ textAlign: 'center' }}>
                {creditSummarydata !== null && creditSummarydata.length > 0 && <>
                    <Grid size={{ xs: 1 }} sx={{ paddingTop: 2, textAlign: 'start' }}>
                        {creditSummarydata && creditSummarydata[0].text}
                        {creditSummarydata && creditSummarydata[2].text.toLowerCase() === "true" ? "*" : ""}
                    </Grid>

                    <Grid size={{ xs: 2 }} sx={{ padding: 2 }}>
                        {creditSummarydata && creditSummarydata[1].text}
                    </Grid>

                    <Grid size={{ xs: 1.5 }} sx={{ padding: 1 }}>
                        <Grid sx={{
                            backgroundColor: creditSummarydata && GetSummaryColorCode(creditSummarydata[3].status.toUpperCase()),
                            textAlign: 'center',
                            padding: 1
                        }}>
                            <b>{creditSummarydata && creditSummarydata[3].text.split('(')[0]}</b>({creditSummarydata && creditSummarydata[3].text.split('(')[1]}
                        </Grid>
                    </Grid>

                    <Grid size={{ xs: 1.5 }} sx={{ padding: 1 }}>
                        <Grid sx={{
                            backgroundColor: creditSummarydata && GetSummaryColorCode(creditSummarydata[4].status?.toUpperCase()),
                            textAlign: 'center',
                            padding: 1
                        }}>
                            <b>{creditSummarydata && creditSummarydata[4].text.split('(')[0]}</b>({creditSummarydata && creditSummarydata[4].text.split('(')[1]}
                        </Grid>
                    </Grid>

                    <Grid size={{ xs: 1.5 }} sx={{ padding: 1 }}>
                        <Grid sx={{
                            backgroundColor: creditSummarydata && GetSummaryColorCode(creditSummarydata[5].status?.toUpperCase()),
                            textAlign: 'center',
                            padding: 1
                        }}>
                            <b>{creditSummarydata && creditSummarydata[5].text.split('(')[0]}</b>({creditSummarydata && creditSummarydata[5].text.split('(')[1]}
                        </Grid>
                    </Grid>

                    <Grid size={{ xs: 1.5 }} sx={{ padding: 1 }}>
                        <Grid sx={{
                            backgroundColor: creditSummarydata && GetSummaryColorCode(creditSummarydata[6].status?.toUpperCase()),
                            textAlign: 'center',
                            padding: 1
                        }}>
                            <b>{creditSummarydata && creditSummarydata[6].text.split('(')[0]}</b>({creditSummarydata && creditSummarydata[6].text.split('(')[1]}
                        </Grid>
                    </Grid>

                    <Grid size={{ xs: 1.5 }} sx={{ padding: 1 }}>
                        <Grid sx={{
                            backgroundColor: creditSummarydata && GetSummaryColorCode(creditSummarydata[7].status?.toUpperCase()),
                            textAlign: 'center',
                            padding: 1
                        }}>
                            <b>{creditSummarydata && creditSummarydata[7].text}</b>
                        </Grid>
                    </Grid>

                    <Grid size={{ xs: 1.5 }} sx={{
                        paddingTop: 2
                    }}>
                        {creditSummarydata && creditSummarydata[8].text}
                    </Grid>
                </>}

                {(creditSummarydata === null || creditSummarydata?.length === 0) &&
                    <Grid size={{ xs: 12 }} sx={{ textAlign: 'center', padding: 5 }}>No records found.</Grid>
                }

                {creditSummarydata && creditSummarydata?.length > 0 && <>
                    {isYearPartialyCompleted === true &&
                        <Grid size={{ xs: 12 }} sx={{ paddingTop: 2, textAlign: 'start' }}>
                            *Partial Year Completed.
                        </Grid>
                    }

                    <Grid size={{ xs: 12 }} sx={{ paddingTop: 2, textAlign: 'start' }}>
                        Note: CPD Category requirements are displayed in brackets.
                    </Grid>

                    <Grid size={{ xs: 12 }} sx={{ paddingTop: 2, textAlign: 'start' }}>
                        <b>Please note: (Req.) = Required  - (Not Req.) =  Not Required.</b>
                    </Grid>
                </>}
            </Grid>
        </Box>
    </Box>
}
